module.exports = __webpack_public_path__ + "img/boldPlus.3af07e76.svg";